/**
 * @function pathToArrayWithoutEmptySpaces - convert path to array and remove empty strings
 * @param {string} path - path to convert to array
 * @param {*} splitBy - delimiter to split by OPTIONAL. Defaults to '/'.
 * @returns {array} - path as an array
 */
export function pathToArrayWithoutEmptySpaces(path, splitBy = "/") {
	return path.split(splitBy).filter((n) => n !== "");
}
